export default __webpack_public_path__ + "static/media/illustration-signup.b097311e.jpg";